import aboutImg from './../../../../website/assets/images/pexels-setengah-lima-sore-1061582751-31783742.jpg'
export default function AboutUsHome() {
  return (<>
    <section class="about" id="about">
      <div class="about-content">
        <h2>motouraX – Fuel Your Freedom</h2>
        <p>
          Welcome to motouraX, the ultimate bike riding app designed for riders who want more than just navigation. Whether you're a daily commuter, weekend explorer, or long-distance touring enthusiast, motouraX helps you track, analyze, and share every ride with precision.
        </p>
        <b>Start your journey. Track your ride. Fuel your freedom.</b>
      </div>
      <div class="about-image">
        <img src={aboutImg} alt="About MOTO" />
      </div>
    </section>
  </>
  );
}
